import { ReactFormExtendedApi } from '@tanstack/react-form'
import { FormHTMLAttributes, PropsWithChildren } from 'react'

import { submitHandler } from './utils'

export type VendiaFormApi<TFormData = any> = ReactFormExtendedApi<
  TFormData,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any
>

export interface FormProps<TFormData = any> extends PropsWithChildren, FormHTMLAttributes<HTMLFormElement> {
  form: VendiaFormApi<TFormData>
}

const Form = <TFormData = any,>({ form, children, onSubmit, ...rest }: FormProps<TFormData>) => {
  if (!form && !onSubmit) {
    throw new Error('Form component must have a form prop or onSubmit prop provided')
  }

  // if onSubmit is provided, use it, otherwise use the submitHandler
  const handleSubmit = onSubmit ?? submitHandler(form)

  return (
    <form onSubmit={handleSubmit} {...rest}>
      {children}
    </form>
  )
}

export default Form
